import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { selectAbacusInstances } from '@platform/platform.selectors';
import { RootState } from '@root/app.state';

@Component({
  selector: 'app-create-user-form',
  templateUrl: './create-user-form.component.html',
  styleUrls: ['./create-user-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CreateUserFormComponent {
  @Input() customerSpaceId: string;
  @Input() cf: UntypedFormGroup;

  @Input() deactivatedBy!: string;
  @Input() deactivationTime!: Date;
  @Input() isPortalAdministrator: boolean;

  @Output() enterClicked = new EventEmitter<any>();

  abacusInstances$ = this.store.select(selectAbacusInstances);

  erpProjectNumber2Label = signal('');
  erpProjectNumber3Label = signal('');
  erpProjectNumber4Label = signal('');

  constructor(
    private store: Store<RootState>,
    private translate: TranslateService,
  ) {
    const erpLabelTranslated = this.translate.instant('customer-spaces.create-customer-form.erp-project-number');
    this.erpProjectNumber2Label.set(`${erpLabelTranslated} 2`);
    this.erpProjectNumber3Label.set(`${erpLabelTranslated} 3`);
    this.erpProjectNumber4Label.set(`${erpLabelTranslated} 4`);
  }

  isInactiveSelected(): boolean {
    return this.cf.get('status')!.value === 'Inactive';
  }
}
